<ng-template #template>
    <div class="modal-header header-style">
      <h3 class="modal-title header-text">{{requestType | providerPipe}} request successfully {{request}}ed.</h3>
      <button type="button" class="close pull-right" aria-label="Close" (click)="closeModal()">  
        <span aria-hidden="true"><img class="resize" src="assets/img/icons/icn-remove-dark.svg" alt="close"></span>  
      </button>  
    </div>
    <div class="modal-body bod-text">
      <div class="container-fluid">
        <div class="row">
          Please include any additional requests and then submit the rest of this form.
        </div>
      </div>
    </div>
    <div id="close" class="modal-footer">
      <a type="button" class="btn-gradient-wrapper" data-dismiss="modal">
        <span class="btn btn-gradient-default mr-auto" (click)="closeModal()">Okay</span>
      </a>
  </div>  
</ng-template>
